<template>
  <div ref="wrap" :style="{width: size + 'px', height: size + 'px', perspective: (size * 3) + 'px'}">
    <div class="absolute inset-0 w-full h-full rotating" style="transform-style: preserve-3d;">
      <div class="absolute inset-0 w-full h-full shading" :style="`transform: rotateY(90deg) translateZ(${size / 2 - 0.5}px);`">
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAElBMVEUAAABzDACUFACkGAi9IAjmIAgd4YarAAAAAXRSTlMAQObYZgAAAF9JREFUGBkFwYFhBCEABCFGL/1X/G6gPwDAZ5qRRge2x/aMg9d6b/PDEc86s3Ny77ZhuE+HV0C/cawNmObQCchyJDmJOPiZd01yr0hPrD6mJdI6am4syWdOakV8ggT4B9TJMj71DhNqAAAAAElFTkSuQmCC"
          class="w-full h-full image-pixelated"
        >
      </div>
      <div class="absolute inset-0 w-full h-full shading reverse" :style="`transform: translateZ(${size / 2 - 0.5}px);`">
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAElBMVEUAAABzDACUFACkGAi9IAjmIAgd4YarAAAAAXRSTlMAQObYZgAAAF9JREFUGBkFwYFhBCEABCFGL/1X/G6gPwDAZ5qRRge2x/aMg9d6b/PDEc86s3Ny77ZhuE+HV0C/cawNmObQCchyJDmJOPiZd01yr0hPrD6mJdI6am4syWdOakV8ggT4B9TJMj71DhNqAAAAAElFTkSuQmCC"
          class="w-full h-full image-pixelated"
        >
      </div>
    </div>
  </div>
</template>

<script>
  import {ref, onMounted} from '@vue/composition-api'

  export default {
    props: {
      size: {
        type: [Number, String],
        required: true,
      },
    },

    setup () {
      let wrap = ref(null)

      onMounted(() => {
        if (!['absolute', 'relative'].includes(getComputedStyle(wrap.value).display)) {
          wrap.value.style.display = 'relative'
        }
      })

      return {
        wrap,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .image-pixelated {
    image-rendering: pixelated;
  }

  $duration: 1s;

  .rotating {
    transform: rotateY(-45deg);
    animation: $duration theme('transitionTimingFunction.in-out') infinite rotating;

    @keyframes rotating {
      0% {
        transform: rotateY(0deg);
      }

      100% {
        transform: rotateY(-90deg);
      }
    }
  }

  .shading {
    &::before {
      @apply block absolute inset-0 w-full h-full bg-black;

      content: '';
      animation: $duration theme('transitionTimingFunction.in-out') infinite dark2light;
    }

    &.reverse::before {
      animation-name: light2dark;
    }

    $light: 0%;
    $dark: 30%;

    @keyframes dark2light {
      0% {opacity: $dark;}
      100% {opacity: $light;}
    }

    @keyframes light2dark {
      0% {opacity: $light;}
      100% {opacity: $dark;}
    }
  }
</style>
